import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from '@/shared/utils/cn';

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors duration-200",
  {
    variants: {
      variant: {
        default: "bg-primary/10 text-primary",
        success: "bg-[hsl(var(--status-active-bg))] text-[hsl(var(--status-active-text))]",
        warning: "bg-[hsl(var(--status-paused-bg))] text-[hsl(var(--status-paused-text))]",
        destructive: "bg-[hsl(var(--status-error-bg))] text-[hsl(var(--status-error-text))]",
        secondary: "bg-secondary text-secondary-foreground",
        outline: "text-foreground border border-border",
        neon: "bg-neon-cyan/10 text-neon-cyan",
        active: "bg-[hsl(var(--status-active-bg))] text-[hsl(var(--status-active-text))]",
        mailed: "bg-[hsl(var(--status-mailed-bg))] text-[hsl(var(--status-mailed-text))]",
        draft: "bg-[hsl(var(--status-draft-bg))] text-[hsl(var(--status-draft-text))]",
        paused: "bg-[hsl(var(--status-paused-bg))] text-[hsl(var(--status-paused-text))]",
        error: "bg-[hsl(var(--status-error-bg))] text-[hsl(var(--status-error-text))]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

const Badge = React.forwardRef<HTMLDivElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return <div ref={ref} className={cn(badgeVariants({ variant }), className)} {...props} />;
  }
);
Badge.displayName = "Badge";

export { Badge, badgeVariants };
